'use es6';

import Application from '../App';
import { getTrackerConfig } from '../tracking/trackerConfig';
import { createTracker } from 'usage-tracker-public';
new Application({
  usageTracker: createTracker(getTrackerConfig(false))
}).startWithNoAuth();